// Single source of truth for AssistanceProgram outbound-link utm_content keys (MVP-30473).
//
// Each value is the utm_content the call site stamps on the program URL (via withUTMParams)
// AND mirrors into the LINK_CLICK reconciliation event — one constant drives both, so the URL
// tag and the event can never diverge. Grouped per surface; the key set differs by what each
// surface actually renders.
//
// These strings are the analytics keys BI / pharma dashboards aggregate on. Do NOT rename or
// restructure them without BI sign-off — changing an emitted value fragments historical data
// (see MVP-30473 acceptance criteria and MVP-30723). Frozen so a call site can't mutate a key.

export const REPORT_CONTACT_UTM = Object.freeze({
  url: "report_contact_provider_application",
  website: "report_contact_program_website",
  pharmacyWebsite: "report_contact_pharmacy_website"
});

export const PS_MODAL_UTM = Object.freeze({
  url: "potential_savings_modal_provider_application",
  website: "potential_savings_modal_program_website"
});

export const POTENTIAL_SAVINGS_UTM_CONTENT_BY_KEY = Object.freeze({
  program: "potential_savings_program_website",
  pharmacy: "potential_savings_pharmacy_website",
  application: "potential_savings_provider_application",
  pharmacyApplication: "potential_savings_pharmacy_application"
});

export const APPLICATION_TOP_UTM_CONTENT_BY_KEY = Object.freeze({
  provider: "application_top_provider_application",
  pharmacy_app: "application_top_pharmacy_application",
  program: "application_top_program_website",
  pharmacy: "application_top_pharmacy_website"
});

export const MANUAL_ENROLLMENT_UTM = Object.freeze({
  provider: "manual_enrollment_provider_application",
  pharmacy: "manual_enrollment_pharmacy_application"
});
